import { useMemo } from 'react';
import { UWEEntity } from '../../../api/types';
import { getReportMetadata, parseNameList } from './util';

export interface ReportSchedules {
  scheduleTitles: string[];
  scheduleNames: string[];
  inventoryScheduleNames: string[];
}

/**
 * The report's regular and inventory schedule lists. The entity's own metadata wins; an amendment
 * carries none of the report's metadata, so it falls back to the amended report's.
 */
export function useReportSchedules(entity: UWEEntity | undefined): ReportSchedules {
  return useMemo(() => {
    const reportMetadata = getReportMetadata(entity);
    const fromEntityOrReport = (key: string) => parseNameList(entity?.metadata?.[key] ?? reportMetadata?.[key]);
    return {
      scheduleTitles: fromEntityOrReport('scheduleTitles'),
      scheduleNames: fromEntityOrReport('scheduleNames'),
      inventoryScheduleNames: parseNameList(reportMetadata?.inventoryScheduleNames),
    };
  }, [entity]);
}
